import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { CommonService } from '../trip-replay/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class TripReplayConfigResolver  {
  constructor(private commonService: CommonService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return new Observable((obs)=>{
      const obsArray=[];
      obsArray.push(this.commonService.getConfig(route.queryParams['buid']))
      forkJoin(obsArray).subscribe(() => {
        obs.next(true);
    }, () => {
        obs.next(true);
    }, () => {
        obs.complete();
    });
    });
  }
}

